import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, InputNumber, Switch, message } from 'antd'
import { getJurisdiction } from '@/statics/js/jurisdiction'
import {
  _getSnRatio,
  _updateSnRatio,
  _get_on_off_type,
  _update_on_off_type,
  _getAlipayRatio,
  _updateAlipayRatio
} from '@/statics/js/api.js'
import './index.less'
const { confirm } = Modal
const ShuntRule = () => {
  const [ratio, setRatio] = useState(0)
  const [state, setState] = useState(0)
  const [alipayRatio, setAlipayRatio] = useState(0)
  const [resourceManageId, setResourceManageId] = useState(null)

  useEffect(() => {
    getSnRatio()
    getType()
    getAlipayRatio()
  }, [])

  // 获取苏宁支付分流比例
  const getSnRatio = async () => {
    const res = await _getSnRatio()
    const { code, message: msg, data } = res.data || {}
    if (code != 200) {
      message.warning(msg)
      return
    }
    setRatio(data.ratio)
  }

  // 获取支付宝快付代扣分流比例
  const getAlipayRatio = async () => {
    const res = await _getAlipayRatio()
    console.log(res, 'res')
    const { code, message: msg, data } = res.data || {}
    if (code != 200) {
      message.warning(msg)
      return
    }
    setAlipayRatio(data.ratioMap.kuaiFuRatio)
    setResourceManageId(data.id)
  }

  //获取类型
  const getType = async () => {
    const res = await _get_on_off_type()
    const { code, message: msg, data } = res.data || {}
    if (code != 200) {
      message.warning(msg)
      return
    }
    setState(data.isHidden)
  }

  //管理状态Switch
  const handleStateChange = async (checked) => {
    let params = { state: Number(!checked) }
    const res = await _update_on_off_type(params)
    const { code } = res.data || {}
    if (code != 200) {
      message.warning('操作失败')
    } else {
      message.success('操作成功')
    }
    getType()
  }

  //修改苏宁支付分流比例
  const showConfirm = () => {
    let ratio
    confirm({
      title: (
        <div style={{ fontSize: '16px', fontWeight: '600', color: '#333', marginBottom: '8px' }}>
          修改基础配置
        </div>
      ),
      content: (
        <div style={{ padding: '16px 0' }}>
          <div
            style={{
              background: '#f8f9fa',
              padding: '16px',
              borderRadius: '6px'
            }}
          >
            <Form.Item
              label={
                <span style={{ fontSize: '14px', color: '#666', fontWeight: '500' }}>
                  苏宁支付分流比例
                </span>
              }
              style={{ marginBottom: '0' }}
            >
              <InputNumber
                min={0}
                max={100}
                style={{ width: '100%' }}
                formatter={(value) => `${value}%`}
                parser={(value) => value.replace('%', '')}
                precision={0}
                placeholder='请输入0-100的整数'
                onChange={(value) => {
                  ratio = value
                }}
              />
            </Form.Item>
          </div>
        </div>
      ),
      okText: '确定',
      cancelText: '取消',
      width: 480,
      async onOk() {
        if (ratio === undefined || ratio === null) {
          message.warning('请输入分流比例')
          return
        }
        let params = {
          ratio
        }
        const res = await _updateSnRatio(params)
        const { code, message: msg, data } = res.data || {}
        if (code != 200) {
          message.warning(msg)
          return
        }
        message.success('配置更新成功')
        getSnRatio()
      }
    })
  }

  //修改支付宝代扣配置
  const showAlipayConfirm = () => {
    let tempAlipayRatio = alipayRatio
    let tempPaiPayRatio = 100 - alipayRatio

    confirm({
      title: (
        <div style={{ fontSize: '16px', fontWeight: '600', color: '#333', marginBottom: '8px' }}>
          修改支付宝代扣配置
        </div>
      ),
      content: (
        <div style={{ padding: '16px 0' }}>
          <div
            style={{
              background: '#f8f9fa',
              padding: '16px',
              borderRadius: '6px'
            }}
          >
            <Form.Item
              label={
                <span style={{ fontSize: '14px', color: '#666', fontWeight: '500' }}>
                  快付代扣分流比例
                </span>
              }
              style={{ marginBottom: '16px' }}
            >
              <InputNumber
                min={0}
                max={100}
                defaultValue={alipayRatio}
                style={{ width: '100%' }}
                formatter={(value) => `${value}%`}
                parser={(value) => value.replace('%', '')}
                precision={0}
                placeholder='请输入0-100的整数'
                onChange={(value) => {
                  tempAlipayRatio = value
                  tempPaiPayRatio = 100 - value
                  // 更新显示的拍付代扣分流比例
                  const paiPayElement = document.getElementById('paiPayRatio')
                  if (paiPayElement) {
                    paiPayElement.textContent = `${tempPaiPayRatio}%`
                  }
                }}
              />
            </Form.Item>
            <Form.Item
              label={
                <span style={{ fontSize: '14px', color: '#666', fontWeight: '500' }}>
                  拍付代扣分流比例
                </span>
              }
              style={{ marginBottom: '0' }}
            >
              <span style={{ fontSize: '14px', color: '#666' }}>
                <span id='paiPayRatio'>{tempPaiPayRatio}%</span>
              </span>
            </Form.Item>
          </div>
        </div>
      ),
      okText: '确定',
      cancelText: '取消',
      width: 520,
      async onOk() {
        if (tempAlipayRatio === undefined || tempAlipayRatio === null) {
          message.warning('请输入快付代扣分流比例')
          return
        }
        let params = {
          ratio: tempAlipayRatio,
          resourceManageId: resourceManageId
        }
        const res = await _updateAlipayRatio(params)
        const { code, message: msg, data } = res.data || {}
        if (code != 200) {
          message.warning(msg)
          return
        }
        message.success('配置更新成功')
        getAlipayRatio()
      }
    })
  }

  return !getJurisdiction() ? (
    '暂无操作权限！'
  ) : (
    <div className='ShuntRule'>
      <div
        className='select-form'
        style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '20px', lineHeight: '80px' }}
      >
        支付分流配置
      </div>

      {/* 基础配置区域 */}
      <div
        style={{
          background: '#f8f9fa',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '24px'
        }}
      >
        <div
          className='select-form'
          style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px', color: '#333' }}
        >
          基础配置
        </div>
        <div className='ratioDiv' style={{ marginBottom: '16px' }}>
          <span style={{ fontSize: '14px', color: '#666' }}>苏宁支付分流比例：</span>
          <span style={{ fontSize: '16px', fontWeight: '500', color: '#1890ff' }}>{ratio}%</span>
          <Button type='link' onClick={showConfirm} style={{ padding: '0 8px' }}>
            修改
          </Button>
        </div>
        <div className='ratioDiv' style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ fontSize: '14px', color: '#666', marginRight: '12px' }}>
            切换支付方式开关：
          </span>
          <Switch
            checked={!state}
            checkedChildren='显示'
            unCheckedChildren='隐藏'
            onChange={handleStateChange}
          />
        </div>
      </div>

      {/* 支付宝代扣配置区域 */}
      <div
        style={{
          background: '#f8f9fa',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '24px'
        }}
      >
        <div
          className='select-form'
          style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px', color: '#333' }}
        >
          支付宝代扣配置
        </div>
        <div className='ratioDiv' style={{ marginBottom: '16px' }}>
          <span style={{ fontSize: '14px', color: '#666' }}>快付代扣分流比例：</span>
          <span style={{ fontSize: '16px', fontWeight: '500', color: '#52c41a' }}>
            {alipayRatio}%
          </span>
          <Button type='link' onClick={showAlipayConfirm} style={{ padding: '0 8px' }}>
            修改
          </Button>
        </div>
        <div className='ratioDiv'>
          <span style={{ fontSize: '14px', color: '#666' }}>拍付代扣分流比例：</span>
          <span style={{ fontSize: '16px', fontWeight: '500', color: '#fa8c16' }}>
            {100 - alipayRatio}%
          </span>
        </div>
      </div>

      {/* 说明区域 */}
      <div
        style={{
          background: '#fff',
          border: '1px solid #e8e8e8',
          padding: '20px',
          borderRadius: '8px'
        }}
      >
        <h3
          style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#333',
            marginBottom: '16px',
            marginTop: '0'
          }}
        >
          解释说明
        </h3>
        <div style={{ fontSize: '14px', lineHeight: '1.6', color: '#666' }}>
          <p style={{ margin: '0 0 8px 0' }}>
            1.
            基础配置指的是苏宁支付与支付宝支付之间的分流（包含主动支付和代扣支付），例：如果配置苏宁支付分流比例为"10%"，会有10%的用户默认苏宁支付路径。
          </p>
          <p style={{ margin: '0 0 8px 0' }}>
            2. 切换支付方式开关：若开关打开，则用户可在下单页面切换支付方式。
          </p>
          <p style={{ margin: '0' }}>3. 支付宝代扣配置：不同的代扣渠道可设置不同比例。</p>
        </div>
      </div>
    </div>
  )
}

export default ShuntRule
